const BASEURL = process.env.VUE_APP_BASEURL
export const apis = {
  imagecode: BASEURL+'/privacy/common/image_code',
  smsSend: BASEURL+'/privacy/common/sms/send',
  getPrivacyAgreementByappid: BASEURL+'/privacy/agreement/get_privacy_agreement_by_appid',
  getprivacyagreementbyid: BASEURL +'/privacy/agreement/get_privacy_agreement_by_id',
  cancellationDecrypt: BASEURL+'/privacy/cancellation/decrypt',
  cancellationCheck: BASEURL+'/privacy/cancellation/check',
  cancellationSubmit: BASEURL+'/privacy/cancellation/submit'
}
